import * as modal from "../util/modal.ts";
import * as i18n from "../i18n.ts";
import ApiServer from "../ApiServer.js";

export function openStorageAlert(onlyOver80=false){
    ApiServer.albumquota(quota=>{
        var percent = Math.min(100,Math.round(100*quota.familyUsed/quota.familyQuota))
        if(onlyOver80 && percent<80) return;
        modal.ask({
            title:"settings.storage.alerttitle",
            message:i18n.get("settings.storage.alertmessage",percent),
            lottie:"/images/lottie/anim_storage_full.json",
            button:[
                {title:'actions.gopremium',class:'premium',action:'takepremium'},
                {title:'actions.later',class:'secondary',action:'modalclose'}
            ]
        })
    })
}
